import React, { useCallback, useContext, useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Switch,
  FlatList,
} from "react-native";
import { Switch as RouterSwitch } from "react-router-dom";
import Icon from "react-native-vector-icons/Feather";
import { useHistory } from "react-router-dom";

import Heading from "~/components/Heading/";
import SolidButton from "~/components/Buttons/SolidButton/";
import Screen from "~/layouts/Screen/index.web";
import SidePanel from "~/components/SidePanel";
import NumbersList from "~/components/NumbersList/";
import AssignmentModal from "~/modals/AssignmentModal/";
import useDraft from "~/hooks/useDraft";
import Engage from "~/services/engage";

import NumberPurchaseModal from "~/modals/NumberPurchaseModal/index.web";
import HashRoute from "~/routers/HashRoute";
import UserContext from "~/contexts/UserContext";
import NumbersContext from "~/contexts/NumbersContext";
import NumberContext, { NumberProvider } from "~/contexts/NumberContext";

import Row from "~/layouts/Row";
import Col from "~/layouts/Col";
import palette from "~/styles/palette";

const VoicemailSettings = () => {
  const { user, getUser } = useContext(UserContext);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const greeting = user.account.default_voicemail_greeting;

  const { draft, dirty, updateDraft, resetDraft } = useDraft({
    default_voicemail_greeting: greeting,
  });

  const onSavePress = () => {
    setSaving(true);
    Engage.updateVoicemailSettings(draft).then((res) => {
      if (res?.status !== 202) {
        setError(res);
      } else {
        getUser().then(() => {
          console.log("fetching user");
          setSuccess(true);
        });
      }

      setSaving(false);
    });
  };

  useEffect(() => {
    console.log("error", error);
  }, [error]);

  return (
    <Row pl={16}>
      <Row pl={16} mt={32}>
        <Heading size={1}>Voicemail Settings</Heading>
      </Row>

      <Row pl={16} pr={16} pt={16}>
        <Heading size={3} mb={0} mt={0}>
          Default Voicemail Message
        </Heading>
      </Row>

      <Row pl={16} pr={16} pt={8}>
        <Col mr={16} pt={8}>
          <TextInput
            numberOfLines={5}
            multiline
            textContentType="none"
            value={draft.default_voicemail_greeting}
            selectTextOnFocus
            style={[
              {
                // backgroundColor: palette.lightest_grey,
                // borderTopWidth: 0,
                // borderLeftWidth: 0,
                // borderRightWidth: 0,
                borderColor: palette.light_grey,
                borderWidth: 1,
                paddingVertical: 12,
                paddingHorizontal: 12,
                fontSize: 16,
                fontWeight: "500",
                // outlineColor: palette.light_grey,
                // outlineOffset: 0,
                // outlineWidth: 0,
                borderRadius: 4,
              },
            ]}
            onChangeText={(value) =>
              updateDraft({ default_voicemail_greeting: value })
            }
          />

          {dirty ? (
            <SolidButton
              onPress={onSavePress}
              loading={saving}
              color={palette.success}
              style={{ marginTop: 32 }}
              // width={80}
              label="Save"
            />
          ) : null}

          {success ? (
            <Heading center size={5} mt={16}>
              Success!
            </Heading>
          ) : null}
        </Col>
      </Row>
    </Row>
  );
};

const NumberSelect = ({ onNumberSelect }) => {
  const history = useHistory();
  const { numbers } = useContext(NumbersContext);

  const onNumberPress = (item) => {
    console.log("item", item);

    if (onNumberSelect) {
      onNumberSelect(item);
    }
  };

  const onPurchaseNumberPress = useCallback(() => {
    history.push({ hash: "purchase-number" });
  }, [history]);

  return (
    <Row>
      <Row pl={32} mt={32} mb={16}>
        <Col>
          <Heading size={1} pb={8}>
            Managed Numbers
          </Heading>
        </Col>

        <Col rightCenter>
          <SolidButton
            mr={32}
            icon="plus"
            label="Purchase Number"
            color={palette.success}
            onPress={onPurchaseNumberPress}
          />
        </Col>
      </Row>

      <Row>
        <NumbersList onNumberPress={onNumberPress} />
      </Row>
    </Row>
  );
};

const NumberSettings = () => {
  const {
    saving,
    loading,
    number,
    dirty,
    error,
    fullNumber,
    saveNumber,
    updateNumber,
  } = useContext(NumberContext);

  const [showAssignments, setShowAssignments] = useState(false);

  const onAssignmentsPress = () => {
    setShowAssignments(true);
  };

  const onAssignmentsClose = () => {
    setShowAssignments(false);
  };

  const onSavePress = () => {
    saveNumber().then((res) => console.log("save press", res));
  };

  return (
    <Row style={{ height: "100%" }}>
      <Col left size={6} pl={32}>
        <Row pl={16} mt={32}>
          <Col>
            <Heading size={1} pb={8}>
              Edit {number.phone_number}
            </Heading>
          </Col>

          {dirty && (
            <Col rightCenter>
              <SolidButton
                mr={32}
                label="Save"
                loading={saving}
                color={palette.success}
                onPress={onSavePress}
              />
            </Col>
          )}
        </Row>

        <Row pl={16} pr={16} pt={16}>
          <Heading size={3} mb={0} mt={0}>
            Label
          </Heading>
        </Row>

        <Row pl={16} pr={16} pt={8} left>
          <Col>
            <TextInput
              textContentType="telephoneNumber"
              value={number.friendly_name}
              selectTextOnFocus
              style={[
                {
                  // backgroundColor: palette.lightest_grey,
                  borderTopWidth: 0,
                  borderLeftWidth: 0,
                  borderRightWidth: 0,
                  borderColor: palette.light_grey,
                  borderWidth: 1,
                  paddingVertical: 12,
                  paddingHorizontal: 12,
                  fontSize: 16,
                  fontWeight: "500",
                  // outlineColor: palette.light_grey,
                  // outlineOffset: 0,
                  // outlineWidth: 0,
                  borderRadius: 4,
                },
              ]}
              onChangeText={(value) => updateNumber({ friendly_name: value })}
            />
          </Col>
        </Row>

        <Row pl={16} pr={16} pt={32}>
          <Heading size={3} mb={0} mt={0}>
            Assigned To
          </Heading>
        </Row>

        <Row pl={16} pr={16} pt={8}>
          <Col
            style={{
              borderBottomWidth: 1,
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderColor: palette.light_grey,
              borderRadius: 4,
            }}
          >
            <Text
              style={[
                {
                  paddingVertical: 12,
                  paddingHorizontal: 12,
                  fontSize: 16,
                  fontWeight: "500",
                },
              ]}
              onPress={onAssignmentsPress}
            >
              {number.assignees?.map((a) => a.name).join(", ")}
            </Text>
          </Col>
        </Row>

        <Row pl={16} pr={16} pt={32}>
          <Heading size={3} mb={0} mt={0}>
            Managers
          </Heading>
        </Row>

        <Row pl={16} pr={16} pt={8}>
          <Col
            style={{
              borderBottomWidth: 0,
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderColor: palette.light_grey,
              borderRadius: 4,
            }}
          >
            <Text
              style={[
                {
                  paddingVertical: 12,
                  paddingHorizontal: 12,
                  fontSize: 16,
                  fontWeight: "500",
                },
              ]}
              // onPress={onAssignmentsPress}
            >
              {number.managers?.map((a) => a.name).join(", ")}
            </Text>
          </Col>
        </Row>

        {!!fullNumber && (
          <Col size={6}>
            <Row pl={16} pr={16} pt={32}>
              <Heading size={3} mb={0} mt={0}>
                General Settings
              </Heading>
            </Row>

            <Row pl={16} pr={16} pt={32}>
              <Col size={10}>
                <Heading size={5}>Notifications enabled</Heading>
              </Col>

              <Col size={2}>
                <Switch
                  value={number.notifications_enabled}
                  onValueChange={(value) =>
                    updateNumber({ notifications_enabled: value })
                  }
                />
              </Col>
            </Row>

            <Row pl={16} pr={16} pt={16}>
              <Col size={10}>
                <Heading size={5}>Voicemail Message</Heading>
              </Col>
            </Row>

            <Row pl={16} pr={16} pt={8}>
              <Col>
                <TextInput
                  // textContentType="telephoneNumber"
                  value={number.voicemail_greeting}
                  selectTextOnFocus
                  style={[
                    {
                      // backgroundColor: palette.lightest_grey,
                      borderTopWidth: 0,
                      borderLeftWidth: 0,
                      borderRightWidth: 0,
                      borderColor: palette.light_grey,
                      borderWidth: 1,
                      paddingVertical: 12,
                      paddingHorizontal: 12,
                      fontSize: 16,
                      fontWeight: "500",
                      // outlineColor: palette.light_grey,
                      // outlineOffset: 0,
                      // outlineWidth: 0,
                      borderRadius: 4,
                    },
                  ]}
                  onChangeText={(value) =>
                    updateNumber({ voicemail_greeting: value })
                  }
                />
              </Col>
            </Row>

            {/*
            <Row pl={16} pr={16} pt={32} pb={32}>
              <Col size={10}>
                <Heading size={5}>Allow incoming calls</Heading>
              </Col>

              <Col size={2}>
                <Switch
                  value={number.incoming_calls_enabled}
                  onValueChange={(value) =>
                    updateNumber({ incoming_calls_enabled: value })
                  }
                />
              </Col>
            </Row>
            */}
          </Col>
        )}
      </Col>

      {showAssignments && <AssignmentModal onBackPress={onAssignmentsClose} />}
    </Row>
  );
};

export default function SettingsScreen() {
  const [settingsPage, setSettingsPage] = useState(null);
  const [selectedNumber, setSelectedNumber] = useState(null);

  const onNumbersPress = () => {
    setSettingsPage("numbers");
  };

  const onVoicemailPress = () => {
    setSettingsPage("voicemail");
    setSelectedNumber(null);
  };

  const onNumberSelect = (item) => {
    setSelectedNumber(item);
  };

  return (
    <Screen safeArea>
      <Row style={[styles.container]}>
        <SidePanel />
        <Col>
          <Row style={[styles.inner]}>
            <Col maxWidth={372} style={[styles.listPanel]}>
              <SettingItem label="Number Management" onPress={onNumbersPress} />
              <SettingItem
                label="Voicemail Settings"
                onPress={onVoicemailPress}
              />
            </Col>

            <Col style={[styles.centerPanel]}>
              {settingsPage === "numbers" && (
                <NumberSelect onNumberSelect={onNumberSelect} />
              )}
              {settingsPage === "voicemail" && <VoicemailSettings />}

              {!settingsPage && (
                <Row center style={{ height: "100%" }}>
                  <Col center>
                    <Heading size={3} style={[styles.greeting]}>
                      Select a settings category
                    </Heading>
                  </Col>
                </Row>
              )}
            </Col>

            {settingsPage === "numbers" && (
              <Col style={[styles.rightPanel]} minWidth="60%">
                {selectedNumber && (
                  <NumberProvider value={selectedNumber}>
                    <NumberSettings />
                  </NumberProvider>
                )}
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <RouterSwitch>
        <HashRoute
          hash="#purchase-number"
          path="/"
          component={NumberPurchaseModal}
        />
      </RouterSwitch>
    </Screen>
  );
}

const SettingItem = ({ label, onPress }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={[styles.list_item]}>
        <Row style={{ height: "100%" }}>
          <Col leftCenter pr={8}>
            <Text style={[styles.list_item__name]}>{label}</Text>
          </Col>
          <Col rightCenter pr={8}>
            <Icon name="chevron-right" color={palette.grey} size={16} />
          </Col>
        </Row>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  greeting: {
    textAlign: "center",
    fontSize: 30,
  },
  text: {
    textAlign: "center",
    fontSize: 18,
    color: palette.grey,
  },
  listPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    height: "100%",
  },
  rightPanel: {
    flexDirection: "column",
    justifyContent: "center",
    // alignItems: "center",
  },
  centerPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    // justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    minWidth: 380,
    height: "100%",
  },
  container: {
    flex: 1,
  },
  inner: {
    height: "100%",
  },

  list_item: {
    height: 65,
    paddingHorizontal: 16,
    paddingRight: 8,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: palette.light_grey,
  },
  list_item__name: {
    fontWeight: "600",
    fontSize: 16,
  },
});
